
import PropTypes from 'prop-types'
import React from 'react'
import css from './WorkspaceNotifications.module.css'

const WorkspaceNotificationHeaderTab = ({ active, title, count, onClick }) => (
  <div
    data-activeHeaderTab={active}
    className={css.HeaderTab}
    onClick={onClick}>
    <span className={css.HeaderTitle} data-activeHeaderTab={active}>{title}</span>
    <span className={css.HeaderCount} data-showHeaderCount={!!count} data-activeHeaderTab={active}>{count}</span>
  </div>
)

WorkspaceNotificationHeaderTab.propTypes = {
  active: PropTypes.bool.isRequired,
  count: PropTypes.number,
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired
}

WorkspaceNotificationHeaderTab.displayName = 'WorkspaceNotificationHeaderTab'

export default WorkspaceNotificationHeaderTab



// WEBPACK FOOTER //
// ./components/WorkspaceNotifications/WorkspaceNotificationsHeaderTab.js